import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import HeaderUno from '../Metodos/Compartidos/HeaderUno';
import HeaderDos from '../Metodos/Compartidos/HeaderDos';

// css
import {Cuerpo, FlexBox} from '../Css/StyledHeader';
import {P, ListadoObjButton} from '../Css/StyledActivities';
import {Circulo} from '../Css/StyledPaciente'
import { Flex } from '../Css/StyledMatematica';


const ScreeningEjercicios = () => {

    const navigate = useNavigate();

    const informacion = [
        {id:'3', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "2", nombre_unidad: "conciencia silábica - segmentar - ensamblar - identificar", nombre_ejercicio: "SCR3", estado: 0},
        {id:'4', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "2", nombre_unidad: "conciencia silábica - segmentar - ensamblar - identificar", nombre_ejercicio: "SCR4", estado: 0},
        {id:'6', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "3", nombre_unidad: "conciencia fonémica - inicial y final - manipulación", nombre_ejercicio: "SCR6", estado: 0},
        {id:'7', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "3", nombre_unidad: "conciencia fonémica - inicial y final - manipulación", nombre_ejercicio: "SCR7", estado: 0},
        {id:'8', seccion: "2", nombre_seccion: "LECTURA", unidad: "4", nombre_unidad: "identificación de letras", nombre_ejercicio: "SCR8", estado: 0},
        {id:'10', seccion: "2", nombre_seccion: "LECTURA", unidad: "6", nombre_unidad: "principio alfabético", nombre_ejercicio: "SCR11", estado: 0},
        {id:'11', seccion: "2", nombre_seccion: "LECTURA", unidad: "7", nombre_unidad: "sílabas", nombre_ejercicio: "SCR12", estado: 0},
        {id:'12', seccion: "2", nombre_seccion: "LECTURA", unidad: "8", nombre_unidad: "palabras", nombre_ejercicio: "SCR13", estado: 0},
        {id:'14', seccion: "2", nombre_seccion: "LECTURA", unidad: "10", nombre_unidad: "pseudopalabras", nombre_ejercicio: "SCR14", estado: 0},
        {id:'15', seccion: "3", nombre_seccion: "DENOMINACIÓN RÁPIDA", unidad: "11", nombre_unidad: "Denominación rápida", nombre_ejercicio: "SCR16", estado: 0},
        {id:'16', seccion: "3", nombre_seccion: "DENOMINACIÓN RÁPIDA", unidad: "11", nombre_unidad: "Denominación rápida", nombre_ejercicio: "SCR17", estado: 0}
    ];

    const [finUnidadUno, setFinUnidadUno] = useState(0);
    const [finUnidadDos, setFinUnidadDos] = useState(0);
    const [finUnidadTres, setFinUnidadTres] = useState(0);
    const [finUnidadCuatro, setFinUnidadCuatro] = useState(0);
    const [finUnidadSeis, setFinUnidadSeis] = useState(0);
    const [finUnidadSiete, setFinUnidadSiete] = useState(0);
    const [finUnidadOcho, setFinUnidadOcho] = useState(0);
    const [finUnidadDiez, setFinUnidadDiez] = useState(0);
    const [finUnidadOnce, setFinUnidadOnce] = useState(0);
    const [iniciado, setIniciado] = useState(false);
    const [nombreEjercicio, setNombreEjercicio] = useState();
    const [nombreUnidad, setNombreUnidad] = useState();
    const [informacionObjetivos, setInformacionObjetivos] = useState(informacion);

    const listaPacientes = useSelector(state => state.informacion.lista_pacientes);
    const idPacienteScreening =  useSelector(state => state.usuario.nombrePaciente);

    const iniciarEjercicio = (e) => {
        e.preventDefault();
        if(iniciado) {
            navigate(`/escritorio/metodos/screening/${nombreEjercicio}`);
        } else {
            navigate(`/escritorio/metodos/screening/SCR1`);
        }
    }

    useEffect(() => {
        const cantidadUno = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 1).length;
        setFinUnidadUno(cantidadUno);
        const cantidadDos = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 2).length;
        setFinUnidadDos(cantidadDos);
        const cantidadTres = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 3).length;
        setFinUnidadTres(cantidadTres);
        const cantidadCuatro = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 4).length;
        setFinUnidadCuatro(cantidadCuatro);
        const cantidadSeis = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 6).length;
        setFinUnidadSeis(cantidadSeis);
        const cantidadSiete = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 7).length;
        setFinUnidadSiete(cantidadSiete);
        const cantidadOcho = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 8).length;
        setFinUnidadOcho(cantidadOcho);
        const cantidadDiez = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 10).length;
        setFinUnidadDiez(cantidadDiez);
        const cantidadOnce = informacionObjetivos.filter(item => item.estado == 1 && item.unidad == 11).length;
        setFinUnidadOnce(cantidadOnce);

        const primerEjercicio = informacionObjetivos.find(item => item.estado == 0)?.nombre_ejercicio;
        const primerUnidad = informacionObjetivos.find(item => item.estado == 0)?.nombre_unidad;

        setNombreEjercicio(primerEjercicio);
        setNombreUnidad(primerUnidad)
        if(primerEjercicio != 'SCR1') {
            setIniciado(true)
        }

    }, [informacionObjetivos])

    useEffect(() => {
        const infoPaciente = listaPacientes.filter(item => item.id_paciente_screening === idPacienteScreening)[0]
        const newList = JSON.parse(JSON.stringify(informacion));
        newList[0].estado = infoPaciente.SCR3;
        newList[1].estado = infoPaciente.SCR4;
        newList[2].estado = infoPaciente.SCR6;
        newList[3].estado = infoPaciente.SCR7;
        newList[4].estado = infoPaciente.SCR8;
        newList[5].estado = infoPaciente.SCR11;
        newList[6].estado = infoPaciente.SCR12;
        newList[7].estado = infoPaciente.SCR13;
        newList[8].estado = infoPaciente.SCR14;
        newList[9].estado = infoPaciente.SCR16;
        newList[10].estado = infoPaciente.SCR17;

        setInformacionObjetivos(newList);

    }, [listaPacientes])

    return (
        <Cuerpo>
            <HeaderUno />
            <HeaderDos link={`/escritorio/screening`} componente={"Pacientes"} paciente={false} />
            <FlexBox justify="center" direction="column" margin="1rem 0 0 0" align="center">
                <Flex width="90%" cursor="pointer">
                    <P border="none" background="#EFC340" borderRadius="10px" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" height="35px" width="100%" padding="0 0 0 0.7rem" style={{display:"flex", justifyContent: "flex-start", alignItems:"center"}}
                        onClick={(e) => iniciarEjercicio(e)}
                    >
                        {iniciado ? `Continuar con ${nombreUnidad}`
                        :
                        "Comience haciendo click aquí"
                        }
                    </P>
                </Flex>
                <Flex width="100%" justify="center" alignItems="start" margin="2rem 1rem 0 1rem">
                    
                    <Flex direction="column" width="50%" justify="center" alignItems="center">
                        <Flex width="75%">
                            <P border="none" background="#EFC340" borderRadius="10px" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" height="35px" width="100%" padding="0 0 0 0.7rem" style={{display:"flex", justifyContent: "flex-start", alignItems:"center"}}>
                                CONCIENCIA FONOLÓGICA
                            </P>
                        </Flex>
                        <Flex direction="column">
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">conciencia silábica - segmentar - ensamblar - identificar</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadDos}/2</P>
                                    {finUnidadDos === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">conciencia fonémica - inicial y final - manipulación</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadTres}/2</P>
                                    {finUnidadTres === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                        </Flex>
                    </Flex>
                    <Flex direction="column" width="50%" justify="center" alignItems="center">
                        <Flex width="75%">
                            <P border="none" background="#EFC340" borderRadius="10px" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" height="35px" width="100%" padding="0 0 0 0.7rem" style={{display:"flex", justifyContent: "flex-start", alignItems:"center"}}>
                                LECTURA
                            </P>
                        </Flex>
                        <Flex direction="column">
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">identificación de letras</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadCuatro}/1</P>
                                    {finUnidadCuatro === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">principio alfabético</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadSeis}/1</P>
                                    {finUnidadSeis === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">sílabas</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadSiete}/1</P>
                                    {finUnidadSiete === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">palabras</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadOcho}/1</P>
                                    {finUnidadOcho === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">pseudopalabras</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadDiez}/1</P>
                                    {finUnidadDiez === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                        </Flex>
                    </Flex>
                    <Flex direction="column" width="50%" justify="center" alignItems="center">
                        <Flex width="75%">
                            <P border="none" background="#EFC340" borderRadius="10px" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" height="35px" width="100%" padding="0 0 0 0.7rem" style={{display:"flex", justifyContent: "flex-start", alignItems:"center"}}>
                                DENOMINACIÓN RÁPIDA
                            </P>
                        </Flex>
                        <Flex direction="column">
                            <ListadoObjButton style={{height:"auto", cursor:"auto"}} padding="0.4rem">
                                <P padding="0px 10px">Denominacion rapida</P>
                                <FlexBox justify="flex-end" margin= "0 0.7rem 0 0">
                                    <P>{finUnidadOnce}/2</P>
                                    {finUnidadOnce === true
                                    ?(<Circulo style={{backgroundColor: "#71AB41"}}></Circulo>)
                                    :(<Circulo style={{backgroundColor: "#EFC340"}}></Circulo>)
                                    }
                                </FlexBox>
                            </ListadoObjButton>
                        </Flex>
                    </Flex>
                </Flex>
            </FlexBox>
        </Cuerpo>
    );
}
export default ScreeningEjercicios;